module.exports = __webpack_public_path__ + "img/arrow_down_gray.36d50439.svg";